export const getDimensionsFromFilename = (
  filename: string,
): { width: number; height: number } | null => {
  const match = filename.match(/\/(\d+)x(\d+)\//)

  if (match) {
    const [, width, height] = match

    return {
      width: parseInt(width, 10),
      height: parseInt(height, 10),
    }
  }

  return null
}
